export default "__VITE_ASSET__DDqc2FSN__"